export default ['date', 'time', 'full'];
